import { render, staticRenderFns } from "./TrainingLoadChart.vue?vue&type=template&id=2375dd92"
import script from "./TrainingLoadChart.vue?vue&type=script&lang=js"
export * from "./TrainingLoadChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports